"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeerNode = void 0;
const peer_1 = require("../agents/peer");
const multimap_1 = require("../../util/multimap");
const Mesh_1 = require("./Mesh");
class PeerNode {
    constructor(resources) {
        this.resources = resources;
        this.peerGroupTokens = new Map();
        this.syncTokens = new Map();
        this.broadcastTokens = new Map();
        this.syncPerPeerGroup = new multimap_1.MultiMap();
    }
    async broadcast(obj, linkupServers, localEndpoints) {
        if (linkupServers === undefined) {
            linkupServers = this.resources.config.linkupServers;
        }
        if (localEndpoints === undefined) {
            localEndpoints = this.resources.getPeersForDiscovery().map((pi) => pi.endpoint);
        }
        const token = this.resources.mesh.startObjectBroadcast(obj, linkupServers, localEndpoints);
        this.broadcastTokens.set(obj.getLastHash(), token);
    }
    async stopBroadcast(obj) {
        const token = this.broadcastTokens.get(obj.hash());
        if (token !== undefined) {
            this.resources.mesh.stopObjectBroadcast(token);
            this.broadcastTokens.delete(obj.getLastHash());
        }
    }
    async sync(obj, mode = Mesh_1.SyncMode.full, peerGroup, gossipId) {
        if (peerGroup === undefined) {
            peerGroup = await this.discoveryPeerGroupInfo(obj);
        }
        const peerGroupKey = PeerNode.generateKey([peerGroup.id]);
        let peerGroupToken = this.peerGroupTokens.get(peerGroupKey);
        if (peerGroupToken === undefined) {
            peerGroupToken = this.resources.mesh.joinPeerGroup(peerGroup);
            this.peerGroupTokens.set(peerGroupKey, peerGroupToken);
        }
        const syncKey = PeerNode.generateKey([obj.hash(), peerGroup.id, gossipId]);
        let syncToken = this.syncTokens.get(syncKey);
        if (syncToken === undefined) {
            syncToken = this.resources.mesh.syncObjectWithPeerGroup(peerGroup.id, obj, mode, gossipId);
            this.syncTokens.set(syncKey, syncToken);
            this.syncPerPeerGroup.add(peerGroupToken, syncToken);
        }
    }
    async stopSync(obj, peerGroupId, gossipId) {
        if (peerGroupId === undefined) {
            peerGroupId = PeerNode.discoveryPeerGroupInfoId(obj);
        }
        const syncKey = PeerNode.generateKey([obj.hash(), peerGroupId, gossipId]);
        const syncToken = this.syncTokens.get(syncKey);
        if (syncToken !== undefined) {
            this.resources.mesh.stopSyncObjectWithPeerGroup(syncToken);
            this.syncTokens.delete(syncKey);
            const peerGroupKey = PeerNode.generateKey([peerGroupId]);
            const peerGroupToken = this.peerGroupTokens.get(peerGroupKey);
            if (peerGroupToken !== undefined) {
                this.syncPerPeerGroup.delete(peerGroupToken, syncToken);
                if (this.syncPerPeerGroup.get(peerGroupToken).size === 0) {
                    this.resources.mesh.leavePeerGroup(peerGroupToken);
                    this.peerGroupTokens.delete(peerGroupKey);
                }
            }
        }
    }
    async discoveryPeerGroupInfo(obj) {
        let localPeer = this.resources.getPeersForDiscovery()[0];
        let peerSource = new peer_1.ObjectDiscoveryPeerSource(this.resources.mesh, obj, this.resources.config.linkupServers, localPeer.endpoint, this.resources.getEndointParserForDiscovery());
        return {
            id: PeerNode.discoveryPeerGroupInfoId(obj),
            localPeer: localPeer,
            peerSource: peerSource
        };
    }
    static discoveryPeerGroupInfoId(obj) {
        return 'sync-for-' + obj.hash();
    }
    static generateKey(parts) {
        let result = '';
        for (const part of parts) {
            if (part !== undefined) {
                if (result.length > 0) {
                    result = result + '-';
                }
                result = result + part.replace(/[-]/g, '--');
            }
        }
        return result;
    }
}
exports.PeerNode = PeerNode;
//# sourceMappingURL=PeerNode.js.map